module.exports = "ol.breadcrumb{min-height:70px;display:flex;align-items:center}a.noactive{text-decoration:none;color:#75787b}form{margin:16px 10px}\n"